export default __webpack_public_path__ + "static/media/balsamiq.a7bccfdf.png";